export default {
  uiStates: {
    title: "Каталог на UI състояния",
    subtitle: "Визуална справка за всички състояния на компоненти — само за разработчици.",

    // Tab names
    tabs: {
      errors: "Състояния на грешки",
      emptyStates: "Празни състояния",
      loading: "Скелетони за зареждане",
      dialogs: "Състояния на диалози",
      misc: "Разни",
    },

    // State labels
    labels: {
      server: "Сървърна грешка",
      network: "Мрежова грешка",
      timeout: "Изтичане на време",
      unknown: "Неизвестна грешка",
      empty: "Празно (няма визити)",
      filteredEmpty: "Филтрирано празно",
      paymentRequired: "Очакващо плащане",
      noResults: "Няма резултати",
      noSamples: "Няма проби",
      noSales: "Няма продажби",
      noProducts: "Няма продукти",
      noPayments: "Няма плащания",
      noVisits: "Няма визити (Досие на пациент)",
      noTests: "Няма изследвания (Досие на пациент)",
      noFlaggedResults: "Няма флагирани резултати",
      dialogHistoryEmpty: "Диалог за история — Празен",
      dialogResultsEmpty: "Диалог за резултати — Празен",
      snackbarSuccess: "Известие за успех",
      snackbarError: "Известие за грешка",
      snackbarWarning: "Известие за предупреждение",
      snackbarInfo: "Информационно известие",
      fullPageSpinner: "Пълностранично зареждане",
      comingSoon: "Очаквайте скоро",
      skeletons: {
        tableRows: "Редове на таблица",
        cardAndTable: "Карта + редове на таблица",
        patientHeader: "Заглавие на пациент + резултати",
        serviceCards: "Карти на услуги",
      },
    },

    // Info tooltips
    usedIn: {
      server: "Използва се в: Таблица с всички посещения, Диалог за резултати, Диалог за флагове",
      network: "Използва се в: Таблица с всички посещения, Диалог за резултати, Диалог за флагове",
      timeout: "Използва се в: Таблица с всички посещения, Диалог за резултати, Диалог за флагове",
      unknown: "Използва се в: Таблица с всички посещения, Диалог за резултати, Диалог за флагове",
      empty: "Използва се в: Таблица с всички посещения (нула резултата)",
      filteredEmpty:
        "Използва се в: Таблица с всички посещения (приложени филтри, няма съвпадение)",
      paymentRequired: "Използва се в: OTP Резултати (просрочено плащане)",
      noResults: "Използва се в: OTP/Корпоративни резултати — DepartmentResultsSection #no-data",
      noSamples: "Използва се в: OTP/Корпоративни резултати — SamplesSection #no-data",
      noSales: "Използва се в: OTP Баланс — секция продажби (няма продажби)",
      noProducts: "Използва се в: OTP Баланс — ProductsTable #no-data (продажбата няма продукти)",
      noPayments: "Използва се в: OTP Баланс — PaymentsTable #no-data (продажбата няма плащания)",
      noVisits: "Използва се в: Досие на пациент — PatientVisitsTable #no-data",
      noTests: "Използва се в: Досие на пациент — PatientTestsTable #no-data",
      noFlaggedResults: "Използва се в: Диалог за флагове — визитата няма флагирани изследвания",
      dialogHistoryEmpty: "Използва се в: Диалог за история — няма предишни резултати за този тест",
      dialogResultsEmpty:
        "Използва се в: Диалог за резултати от визита — няма резултати за показване",
      snackbarSuccess: "Използва се в: Изчистване на кеш, потвърждения за PDF",
      snackbarError: "Използва се в: Всички грешки при мутации чрез useErrorBoundary",
      snackbarWarning: "Използва се в: Грешки при фоново обновяване",
      snackbarInfo: "Използва се в: Известия за неимплементирани функции",
      fullPageSpinner:
        "Използва се в: OTP входна страница (проверка на автентикация), страница за вход",
      comingSoon: "Използва се в: Търсене, Нови резултати, Отбелязани страници",
      tableRows: "Използва се в: Страница с всички посещения",
      cardAndTable: "Използва се в: OTP Баланс",
      patientHeader: "Използва се в: OTP Резултати",
      serviceCards: "Използва се в: Страница За нас (раздел Услуги)",
    },

    // Fixture text
    fixture: {
      serverTitle: "Нещо се обърка",
      serverSubtitle:
        "Възникна сървърна грешка при зареждане на данните. Моля, опитайте отново или се свържете с поддръжката.",
      networkTitle: "Изгубена връзка",
      networkSubtitle:
        "Няма връзка със сървъра. Моля, проверете интернет връзката и опитайте отново.",
      timeoutTitle: "Времето за изчакване изтече",
      timeoutSubtitle:
        "Заявката не бе обработена навреме. Вероятно е временен проблем — опитайте отново след малко.",
      unknownTitle: "Неочаквана грешка",
      unknownSubtitle: "Възникна неочаквана грешка. Моля, опитайте отново по-късно.",
      emptyTitle: "Няма намерени визити",
      emptySubtitle: "В системата все още няма регистрирани визити.",
      filteredEmptyTitle: "Няма съвпадащи визити",
      filteredEmptySubtitle: "Няма визити, отговарящи на текущите филтри.",
      paymentTitle: "Очакващо плащане",
      paymentSubtitle:
        "Вашите лабораторни резултати са готови, но достъпът до тях изисква заплащане на дължимата сума. Моля, обърнете се към рецепция или касата на лабораторията.",
      noResultsTitle: "Няма налични резултати",
      noResultsSubtitle: "Няма регистрирани резултати от изследване за тази визита.",
      noSamplesTitle: "Няма регистрирани проби",
      noSamplesSubtitle: "Няма регистрирано вземане на проби за тази визита.",
      noSalesTitle: "Няма регистрирани продажби",
      noSalesSubtitle: "За това посещение не са регистрирани продажби.",
      noProductsTitle: "Няма регистрирани продукти",
      noProductsSubtitle: "Няма регистрирани продукти за тази продажба.",
      noPaymentsTitle: "Няма извършени плащания",
      noPaymentsSubtitle: "За тази продажба няма регистрирано нито едно плащане.",
      noVisitsTitle: "Няма намерени визити за този пациент.",
      noVisitsSubtitle: "Няма записани визити за този пациент.",
      noTestsTitle: "Няма намерени изследвания за този пациент.",
      noTestsSubtitle: "Няма записани изследвания за този пациент.",
      noFlaggedResultsTitle: "Няма флагирани резултати",
      noFlaggedResultsSubtitle: "Няма флагирани резултати в тази визита.",
      historyEmptyTitle: "Не са намерени исторически резултати за този тест",
      historyEmptySubtitle: "Няма записани предишни резултати за този тест.",
      retry: "Повторен опит",
      clearFilters: "Изчистване на филтрите",
      editFilters: "Промяна на филтрите",
      authTitle: "Сесията изтече",
      authSubtitle: "Вашата сесия изтече. Моля, влезте отново.",
      validationTitle: "Невалидни данни",
      validationSubtitle: "Моля, коригирайте маркираните полета и опитайте отново.",
      comingSoonTitle: "Очаквайте скоро",
      comingSoonSubtitle: "Тази функция е в процес на разработка.",
      snackbarSuccessText: "Операцията завърши успешно",
      snackbarErrorText: "Възникна грешка. Моля, опитайте отново.",
      snackbarWarningText: "Обновяването на данните не е успешно.",
      snackbarInfoText: "Функцията все още не е реализирана.",
      login: "Повторен вход",
      refresh: "Обновяване",
    },
  },
};
